// extracted by mini-css-extract-plugin
module.exports = {"main":"ComponentOverview_main__lb61K","flex":"ComponentOverview_flex__3iHzH","col":"ComponentOverview_col__rmfxH"};